import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './style.module.scss';
import logo_negro_color from '../../../images/logo_negro_color.png';
import logo_blanco_color from '../../../images/logo_blanco_color.png';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const LoadingModalContext = React.createContext({});

export function LoadingModalContextProvider(props) {
	const [isOpen, setOpen] = useState(false);

	const theme = useTheme();
	const prefersDarkMode = theme.palette.mode === "dark";
	const isBigScreen = useMediaQuery(theme.breakpoints.up('xl')) ? true : false;

	// Prevent background from retaining focus while modal is open
	useEffect(() => {
		const rootEl = document.getElementById('root');
		if (!rootEl) return;
		if (isOpen) {
			try {
				// Blur any focused element in the background
				if (document.activeElement && typeof (document.activeElement).blur === 'function') {
					(document.activeElement).blur();
				}
				// Make background inert so it can't receive focus/interactions
				rootEl.setAttribute('inert', '');
			} catch {}
		} else {
			try { rootEl.removeAttribute('inert'); } catch {}
		}
		return () => {
			try { rootEl.removeAttribute('inert'); } catch {}
		};
	}, [isOpen]);

	return (
		<LoadingModalContext.Provider value={{ isOpen, setOpen }}>
			{props.children}

			<Dialog
				open={isOpen} aria-labelledby="loading-dialog-title"
				className={styles.dialog}
				fullWidth maxWidth={isBigScreen ? "md" : "sm"}
			>
				<DialogContent className={styles.dialogContent}>
					<img src={ prefersDarkMode ? logo_blanco_color : logo_negro_color } alt="logo"/>

					<CircularProgress />
				</DialogContent>

				<DialogTitle className={styles.dialogTitle} id="loading-dialog-title">Cargando</DialogTitle>
			</Dialog>
		</LoadingModalContext.Provider>
	);
}